import { Component, Input, OnInit } from '@angular/core';
import { CustomerDetailsModel } from '../customer-details.model';

@Component({
  selector: 'app-bank-details',
  templateUrl: './bank-details.component.html',
  styleUrls: ['./bank-details.component.scss']
})
export class BankDetailsComponent implements OnInit{
@Input() bankDetails=new CustomerDetailsModel();

ngOnInit(): void {
  this.bankDetails
}
}
